import { FormControl, useTheme } from '@mui/material';
import { Controller } from 'react-hook-form';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { LabelSmall } from 'v3/shared/typography/LabelSmall';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { FormControlLabelStyled, RadioGroupStyled, RadioStyled } from './styles';
import { RadioFormControllerProps } from './types';

export function RadioFormController({
  formControl,
  formControlName,
  label,
  defaultValues,
  disabled,
}: RadioFormControllerProps) {
  const theme = useTheme();

  const getDefaultValuesFormControlLabels = () => {
    const defaultValuePairs = Object.entries(defaultValues).map(([key, value]) => ({
      key: key,
      value: value,
    }));

    const formControlLabels = defaultValuePairs.map((item, index) => (
      <FormControlLabelStyled
        id={`${label}-${index}`}
        key={`${label}-${index}`}
        value={item.value}
        control={<RadioStyled inputProps={{ 'data-testid': `radio-${label}` }} name={item.key} />}
        label={<SubtitleMedium children={item.key} />}
        disabled={disabled}
      />
    ));

    return formControlLabels;
  };

  return (
    <Controller
      name={formControlName}
      control={formControl}
      render={({ field, fieldState: { error } }) => {
        return (
          <FormControl fullWidth>
            <FormControlLabelStyled
              id={label}
              label={<LabelSmall children={label} />}
              labelPlacement="top"
              control={
                <RadioGroupStyled {...field} row>
                  {getDefaultValuesFormControlLabels()}
                </RadioGroupStyled>
              }
            />
            {error ? (
              <BodySmallRegular marginTop={0} color={theme.palette.error.main}>
                {error.message}
              </BodySmallRegular>
            ) : null}
          </FormControl>
        );
      }}
    />
  );
}
